import {UI} from "../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../stem-core/src/ui/Style";

import {DONATE_PAGE_URLS} from "../../PaywallConstants";
import {Messages} from "../../../Messages";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {donateMobileState} from "../../inline-donation/DonateMobileState";
import {DonationStore} from "../../../../client/state/DonationStore";
import {DonateHomePayWithAddedCardComponent} from "../pay-with-card/PayWithAddedCardPanel";
import {styleRule} from "../../../../stem-core/src/ui/Style";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PaymentMethodStore} from "../../../../client/state/PaymentMethodStore";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";


class EditAddCardPanelStyle extends StyleSheet {
    @styleRule
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        margin: "20px 0 0",
    };

    @styleRule
    back = this.themeProps.DONATE_PAGE_LINK;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };
}

@registerStyle(EditAddCardPanelStyle)
export class EditAddCardPanel extends UI.Element {
    getDonation() {
        return iFrameUserDataService.getActiveRecurringDonation();
    }

    render() {
        const {styleSheet} = this;

        return [
            <DonateHomePayWithAddedCardComponent ref="cardComponent" onChange={() => this.redraw()}
                                                 title={Messages.updatePaymentMethod}/>,
            <MerchantButton className={styleSheet.button} disabled={!this.cardComponent?.isValid()}
                            onClick={() => this.continue()}>
                {Messages.addNewCard}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.back} className={styleSheet.back}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.editChooseCard)}/>
            </div>,
            <PoweredByBlink/>
        ];
    }

    continue() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(PaymentMethodStore.Scope.RECURRING_PAYMENT, preferredPaymentMethodId => {
            donateMobileState.updateEditDonationPaymentMethod(PaymentMethodStore.get(preferredPaymentMethodId));
            LoadingSpinner.hide();
            this.options.changeURL(DONATE_PAGE_URLS.editChooseCard, true);
        }, () => {
            // Error rendering is done in the card component.
            LoadingSpinner.hide();
        });
    }

    onMount() {
        super.onMount();
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument() && !this.getDonation()) {
                    this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
